import { Helmet } from 'react-helmet';

const SEO = ({ 
  title = "Paints for Home| Wall & Roof Paints - Kamdhenu Paints",
  description = "Kamdhenu paints is the best home painting, wall and roof paints manufacturer in India. Explore a wide range of Home wall paint colors and waterproofing solutions.",
  keywords = "paints for home, home painting colour, house paint, house painting, paint for house, paint shop near me",
  canonical
}) => {
  // Automatically generate canonical URL if not provided
  const getCanonicalUrl = () => {
    if (canonical) {
      return canonical;
    }
    
    // Get current URL from window.location
    if (typeof window !== 'undefined') {
      const { protocol, host, pathname } = window.location;
      // Remove trailing slash if present (except for homepage)
      const cleanPath = pathname === '/' ? pathname : pathname.replace(/\/$/, '');
      return `${protocol}//${host}${cleanPath}`;
    }
    
    // Fallback to homepage if window is not available (SSR)
    return "https://www.kamdhenupaints.com/";
  };

  const canonicalUrl = getCanonicalUrl();

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default SEO;
